module.exports = {"130634100":"恒州镇","130634101":"灵山镇","130634102":"燕赵镇","130634103":"羊平镇","130634104":"文德镇","130634105":"晓林镇","130634200":"路庄子乡","130634201":"下河乡","130634202":"庄窠乡","130634203":"孝墓乡","130634205":"东旺乡","130634207":"邸村乡","130634208":"产德乡","130634209":"齐村乡","130634210":"党城乡","130634211":"郎家庄乡","130634212":"范家庄乡","130634213":"北台乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130634.json
// module id = 152
// module chunks = 0